import React from 'react';
import { Page } from '../Page';
import { Target, TrendingUp, RefreshCw } from 'lucide-react';
export function PageContext() {
  return <Page pageNumber={8} variant="light" data-id="element-899">
      <div className="flex flex-col h-full" data-id="element-900">
        <div className="mb-8 pt-4" data-id="element-901">
          <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-902">
            The Fundamentals
          </p>
          <h1 className="text-5xl font-serif text-[#1F1F1F] leading-tight mb-4" data-id="element-903">
            Numbers Are a<br data-id="element-904" />
            <span className="text-tealslate" data-id="element-905">Starting Point</span>
          </h1>
          <div className="w-16 h-0.5 bg-tealslate" data-id="element-906" />
        </div>

        <div className="grid grid-cols-2 gap-10 mb-10" data-id="element-907">
          <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-908">
            Calculators and formulas give you a baseline, but your body is not a
            spreadsheet. The medication changes how your body responds to food.
            Here is how to adjust those numbers based on how you actually feel.
          </p>
          <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-909">
            No matter the calorie goal, protein goal, fiber goal, or any other
            number you are given, the way we determine if those numbers are
            correct is whether they are giving you positive outcomes.
          </p>
        </div>

        <div className="space-y-5 mb-8" data-id="element-910">
          {[{
          icon: Target,
          title: 'Outcomes Over Numbers',
          text: 'If your numbers are not giving you positive outcomes and positive progression toward your goals, those numbers need to change.'
        }, {
          icon: RefreshCw,
          title: 'Adjust as You Go',
          text: "You do not have to hit these numbers exactly every single day. What matters is the trend over time. Some days you'll overshoot, some days you'll fall short."
        }, {
          icon: TrendingUp,
          title: "How to Know It's Working",
          text: 'Are you losing weight at a healthy pace? Do you have energy? Is your hair staying healthy? Are you maintaining strength? If yes, your numbers are working.'
        }].map((item, i) => <div key={i} className="flex items-start gap-4" data-id="element-911">
              <div className="w-10 h-10 rounded-full bg-[#EAEAE4] border border-[#D8D8D0] flex items-center justify-center shrink-0 mt-0.5" data-id="element-912">
                <item.icon className="w-5 h-5 text-tealslate" data-id="element-913" />
              </div>
              <div data-id="element-914">
                <h3 className="text-sm font-bold text-[#1F1F1F] mb-1" data-id="element-915">
                  {item.title}
                </h3>
                <p className="text-xs text-[#7A7A70] leading-[1.8]" data-id="element-916">
                  {item.text}
                </p>
              </div>
            </div>)}
        </div>

        <div className="flex-1 flex items-end" data-id="element-917">
          <div className="bg-[#EAEAE4] border-l-4 border-tealslate px-6 py-4 w-full" data-id="element-918">
            <p className="text-sm text-[#1F1F1F]" data-id="element-919">
              <strong className="text-tealslate" data-id="element-920">The bottom line:</strong> Use
              the numbers in this guide as your starting point. Then let your
              results tell you whether to stay the course or make a change.
            </p>
          </div>
        </div>
      </div>
    </Page>;
}